import { render, staticRenderFns } from "./ListTerminals.vue?vue&type=template&id=65ca54c7&lang=pug"
import script from "./ListTerminals.vue?vue&type=script&lang=js"
export * from "./ListTerminals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports